import { map, take } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Appointment } from '../../appointment/store/one-time-appointment/appointment.entity';
import { Conference, ConferenceToken } from '../store/conference.entity';
import { ProfileSelectService } from '../../profile/providers/profile-select.service';
import { Store } from '@ngrx/store';
import { getConferenceByIdSelector, selectAllConferences } from '../store/conference.selector';
import { Observable, Subject, zip } from 'rxjs';

export interface ConferenceResource {
    tokenId: number;
    conferenceId: number;
    token: string;
    profileId: number;
}

export interface ConferenceResponse {
    success?: boolean;
    items: ConferenceResource[];
}

@Injectable()
export class ConferenceService {
    private conferenceEndpoint = environment.conferenceListEndpoint;

    constructor(private http: HttpClient,
                private profileSelectService: ProfileSelectService,
                private store: Store<any>) {
    }

    // used in store effect ot start when APPOINTMENTS_INITIAL_RECEIVED_SUCCESSFUL trigert -> CONFERENCE_LIST_ADD_SUCCESS
    public getConferenceList(aList: Appointment[]): Observable<Conference[]> {
        const list: Observable<Conference>[] = [];
        aList.forEach((appointment) => {
            const subject = new Subject();
            this.getConference(appointment.conferenceId).subscribe(subject);
            list.push(new Observable((observer) => subject.subscribe(observer)));
        });
        return this.zip(list);
    }

    public getConferenceListFromStore(): Observable<Conference[]> {
        return this.store.select(selectAllConferences).pipe(take(1));
    }

    public getConferenceById(id): Observable<Conference> {
        return this.store.select(getConferenceByIdSelector(id));
    }

    public getConference(id: number): Observable<Conference> {
        const currentProfileId = this.profileSelectService.getCurrentProfileId();
        return this.http.get(this.conferenceEndpoint + '/' + id, {}).pipe(
            map((response: ConferenceResponse) => this.mapToConferenceEntity(response.items, id, currentProfileId)));
    }

    public getActiveConference(): Observable<number> {
        return this.store.select(s => s.conference.activeId);
    }

    public mapToConferenceEntity(resources: ConferenceResource[], id: number, currentProfileId: number): Conference {
        const conference: Conference = {id: Number(id), myToken: null, userTokens: {}};

        resources.forEach((cr: ConferenceResource) => {
            const token: ConferenceToken = {id: Number(cr.tokenId), profileId: Number(cr.profileId), token: cr.token};
            if (currentProfileId === token.profileId) {
                conference.myToken = token;
            } else {
                conference.userTokens[token.profileId] = token;
            }
        });

        return conference;
    }

    private zip(conference$: Observable<Conference>[]): Observable<Conference[]> {
        return zip(...conference$);
    }
}
